import React, { useState } from 'react'
import CustomModal from './CustomModal'
import '../../views/dashboard/dashboard.css'
import { PutApi } from 'app/utils/helper'
import { Apis } from 'app/Apis/Apis'
import { toast } from 'react-toastify'

const ResetPasswordModal = ({ showModal, setShowModal, email }) => {
    const [newPass, setNewPass] = useState('')

    const resetPassword = async () => {
        try {
            await PutApi(`${Apis.resetPasswordForDoctor}`, {
                _id: email?._id,
                newPass: newPass,
            })
            toast.success('Password reset successfully!')
            setShowModal(false)
        } catch (error) {
            toast.error(
                'Password Should Contain \n atleast 8 to 20 Characters \n with Capital and Small Letter \n Number \n symbols(-._@) !'
            )
            console.error('Error resetting password:', error?.message)
        }
    }

    const handleChange = (e) => {
        setNewPass(e.target.value)
    }

    return (
        <div>
            <CustomModal
                title="Reset Password"
                showModal={showModal}
                setShowModal={setShowModal}
            >
                <div className="modal-body">
                    <div className="input-container">
                        <label htmlFor="input" className="label">
                            Email
                        </label>
                        <input
                            type="text"
                            id="input"
                            value={email.email}
                            readOnly
                        />
                    </div>

                    <div className="input-container">
                        <label htmlFor="input" className="input-label">
                            New Password
                        </label>
                        <input
                            placeholder="Enter the New Password"
                            className="input-field"
                            type="password"
                            name="newPass"
                            value={newPass}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="">
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={resetPassword}
                        >
                            Reset Password
                        </button>
                    </div>
                </div>
            </CustomModal>
        </div>
    )
}

export default ResetPasswordModal
